import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import React from 'react';
import { colorPalette } from '../styles/partials/colors';

export const editDeleteOptions = [
  { label: 'Edit', value: '1', icon: <EditIcon sx={{ color: colorPalette.primaryBlue }} /> },
  { label: 'Delete', value: '2', icon: <DeleteIcon sx={{ color: colorPalette.primaryBlue }} /> },
];
